export function getTagItemIndex(element: HTMLElement): number {
  if (element) {
    const indexAttribute = element.attributes.getNamedItem("data-index");
    if (indexAttribute) {
      return Number(indexAttribute.value);
    }
  }

  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'number'.
  return null;
}

export function getTagItemByIndex(listRef: React.RefObject<HTMLDivElement>, index: number): HTMLElement {
  if (listRef && listRef.current) {
    return listRef.current.childNodes.item(index) as HTMLElement;
  }

  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'HTMLElement... Remove this comment to see the full error message
  return null;
}

export function focusElementByIndex(listRef: React.RefObject<HTMLDivElement>, index: number): void {
  if (listRef && listRef.current) {
    const elementByIndex = getTagItemByIndex(listRef, index);
    if (elementByIndex) {
      (elementByIndex as HTMLDivElement).classList.add("focused");
    }
  }
}

export function isNextElementAvailable(focusedElement: Element): boolean {
  if (focusedElement) {
    const nextElement = focusedElement.nextElementSibling;
    if (nextElement) {
      return true;
    }
  }

  return false;
}

export function isPreviousElementAvailable(focusedElement: Element): boolean {
  if (focusedElement) {
    const previousElement = focusedElement.previousElementSibling;
    if (previousElement) {
      return true;
    }
  }

  return false;
}

export function changeElementsFocus(removeFocusElement: Element, addFocusElement: Element): void {
  removeFocusElement.classList.remove("focused");
  addFocusElement.classList.add("focused");
}

export function isLastElementAvailable(listRef: React.RefObject<HTMLDivElement>, focusedElement: Element): boolean {
  if (focusedElement) {
    // @ts-expect-error TS(2339): Property 'lastElementChild' does not exist on type... Remove this comment to see the full error message
    const { lastElementChild } = listRef.current;
    if (lastElementChild) {
      return true;
    }
  }

  return false;
}

export function isFirstElementAvailable(listRef: React.RefObject<HTMLDivElement>, focusedElement: Element): boolean {
  if (focusedElement) {
    // @ts-expect-error TS(2339): Property 'firstElementChild' does not exist on typ... Remove this comment to see the full error message
    const { firstElementChild } = listRef.current;
    if (firstElementChild) {
      return true;
    }
  }

  return false;
}

export function clearFocus(listRef: React.RefObject<HTMLDivElement>): void {
  if (listRef && listRef.current) {
    const foundElements = Array.from(listRef.current.querySelectorAll(".focused"));
    foundElements.forEach(element => {
      element.classList.remove("focused");
    });
  }
}
